import { render } from "./AudiencesForm.vue?vue&type=template&id=3863004f&scoped=true"
import script from "./AudiencesForm.vue?vue&type=script&lang=js"
export * from "./AudiencesForm.vue?vue&type=script&lang=js"

import "./AudiencesForm.vue?vue&type=style&index=0&id=3863004f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3863004f"]])

export default __exports__